import { Badge } from '@/components/ui/badge'
import { creditLeft } from '@/lib/credit-notes'
import type { Invoice } from '@riverpark/types'

export function CreditStatusBadge({ credit }: { credit: Invoice }) {
  if (credit.status === 'voided') return <Badge variant="default">Voided</Badge>
  if (creditLeft(credit) <= 0) return <Badge variant="default">Used up</Badge>
  return credit.amountPaid > 0 ? (
    <Badge variant="credit">Partly used</Badge>
  ) : (
    <Badge variant="credit">Unused</Badge>
  )
}
